module.exports = __webpack_public_path__ + "6911808d0084a753f982e8a8f79d74ed.svg";